module.exports = __webpack_public_path__ + "img/vikings-DE.0a307a30.png";